import { render, staticRenderFns } from "./CommonTab.vue?vue&type=template&id=2e3c0f78&scoped=true&"
import script from "./CommonTab.vue?vue&type=script&lang=js&"
export * from "./CommonTab.vue?vue&type=script&lang=js&"
import style0 from "./CommonTab.vue?vue&type=style&index=0&id=2e3c0f78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3c0f78",
  null
  
)

export default component.exports